import { Theming } from '~schemas/settings';

/**
 * Default light theming values used as the baseline for light branding.
 * Individual values are overridden at runtime by the /v2/branding API response.
 */
export const DEFAULT_LIGHT_THEME: Theming = {
  fonts: {
    heading: { family: 'Poppins' },
    body: { family: 'Inter' },
  },
  surface: {
    primary: '#FFFFFF',
    primary_support: '#EAEDF1',
    primary_support_soft: '#F3F5F7',
    neutral: '#DBE1E7',
    focus: '#3A79FF',
    positive: '#3BD66F',
    positive_support: '#EDFCF2',
    warning: '#F5B71E',
    warning_support: '#FEF8E8',
    error: '#FF4667',
    error_support: '#FFEBEF',
    shadow: '#09218719',
    hover: '#00000019',
    video_overlay_button: '#00000019',
    modal_overlay: '#FFFFFFEB',
  },
  border: {
    primary: '#DBE1E7',
    disabled: '#EAEDF1',
    hover: '#B7C6D2',
  },
  text: {
    heading: '#092187',
    body: '#092187',
    secondary: '#7186A0',
    focus: '#FFFFFF',
    disabled: '#DBE1E7',
    overlay_disabled: '#FFFFFF33',
  },
};

/**
 * Default dark theming values used as the baseline for dark branding.
 * Individual values are overridden at runtime by the /v2/branding API response.
 */
export const DEFAULT_DARK_THEME: Theming = {
  fonts: {
    heading: { family: 'Poppins' },
    body: { family: 'Inter' },
  },
  surface: {
    primary: '#181E25',
    primary_support: '#0D1014',
    primary_support_soft: '#F3F5F7',
    neutral: '#2A323E',
    focus: '#3A79FF',
    positive: '#3BD66F',
    positive_support: '#0B411E',
    warning: '#F5B71E',
    warning_support: '#493503',
    error: '#FF4667',
    error_support: '#4C000E',
    shadow: '#00000019',
    hover: '#FFFFFF19',
    video_overlay_button: '#00000019',
    modal_overlay: '#000000EB',
  },
  border: {
    primary: '#3B4C5D',
    disabled: '#2A323E',
    hover: '#4A5E70',
  },
  text: {
    heading: '#FFFFFF',
    body: '#FFFFFF',
    secondary: '#7186A0',
    focus: '#FFFFFF',
    disabled: '#3B4C5D',
    overlay_disabled: '#FFFFFF33',
  },
};
